import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import ErrorPage from "./ErrorPage";

export default function NotFound({ subdomain }: { subdomain: string }) {
    const pathname = useLocation().pathname;
    const [searchParmas] = useSearchParams();

    // /index.html /index.asp 및 ?p_url= 로 페이지 접근시 메인 화면으로 이동하도록 처리
    if (pathname === "/index.html" || pathname === "/index.asp" || searchParmas.get("p_url")) {
        return <Navigate to="/" replace />;
    }

    return <ErrorPage status={404} subdomain={subdomain} />;
}
